import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Typography, Container, TextField, Button, Grid, Snackbar, Alert } from '@mui/material';
import { YouTube, Instagram, Twitter } from '@mui/icons-material';
import { contactFormStart } from '../../../store/user/action';


const ContactPage = () => {
  const [firstname, setFirstname] = useState('');
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');
  const dispatch = useDispatch();
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(contactFormStart(firstname, message, email));
    setOpenSnackbar(true);
  };

  return (
    <Box sx={{ backgroundColor: '#f9f9f9', minHeight: '100vh' }}>
      <Box sx={{
        background: 'linear-gradient(to bottom, #F5F9ED, #E6F2E0)',
        color: 'white',
        textAlign: 'center',
        paddingY: 25,
      }}>
        <Typography variant="h2" fontWeight={700}>Get in Touch with US!</Typography>
        <Typography variant="h5" sx={{ marginTop: 2, opacity: 0.9 }}>We’d love to hear from you!</Typography>
      </Box>
      <Container maxWidth="md" sx={{ paddingY: 6 }}>
        <Box sx={{ marginTop: 6, backgroundColor: 'white', padding: 5, borderRadius: 3, boxShadow: 4 }}>
          <Typography variant="h5" fontWeight={600} color="primary" sx={{ textAlign: 'center', marginBottom: 3 }}>
            Send Us a Message
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField fullWidth label="Name" value={firstname} onChange={(e) => setFirstname(e.target.value)} required />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth type="email" label="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth multiline rows={4} label="Message" value={message} onChange={(e) => setMessage(e.target.value)} required />
              </Grid>
              <Grid item xs={12} sx={{ textAlign: 'center' }}>
                <Button type="submit" variant="contained" color="primary" size="large">Send Message</Button>
              </Grid>
            </Grid>
          </form>
        </Box>
        
      </Container>
      <Snackbar open={openSnackbar} autoHideDuration={4000} onClose={() => setOpenSnackbar(false)}>
        <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
          Thank you for reaching out! We'll get back to you soon.
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ContactPage;
